<template>

    <spinner-until :condition="surveyId != null">

        <div class="survey-create">

            <survey-form :survey-id="surveyId"
                         v-if="surveyId">
            </survey-form>

        </div>

    </spinner-until>
</template>

<!-- -------------------------------------------------------- -->

<script>
    import Vue from 'vue'

    /**
     * Page for a Participant to begin a Survey
     */
    export default Vue.extend({
        name: 'SurveyCreate',
        props: {
            questionnaireCode: String,
            participantId: Number,
            forPractitioner: Boolean
        },
        data() {
            return {
                surveyId: null
            }
        },
        mounted() {
            this.$api.createSurvey(this,
                this.questionnaireCode,
                this.participantId)
                .then((response) => {
                    this.surveyId = response.data
                    let route = 'fill'
                    if (this.forPractitioner) {
                        route = 'doctorFill'
                    }
                    this.$router.replace(`/survey/${route}/id/${this.surveyId}/participantId/${this.participantId}`)
                })
        },
    });

</script>
